module.exports = __webpack_public_path__ + "img/church.ac4ee762.jpg";